import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { DiagnosticsService } from '../services/diagnostics.service';
import { scrubUrl } from '../observability/sentry-init';

export const diagnosticsInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const diagnostics = inject(DiagnosticsService);
  const startedAt = performance.now();

  if (isMutatingRequest(req.method)) {
    diagnostics.addBreadcrumb('http', `${req.method} started`, {
      method: req.method,
      url: scrubUrl(req.urlWithParams || req.url),
    }, 'debug');
  }

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && isMutatingRequest(req.method)) {
        diagnostics.addBreadcrumb('http', `${req.method} completed`, {
          method: req.method,
          url: scrubUrl(req.urlWithParams || req.url),
          status: event.status,
          durationMs: Math.round(performance.now() - startedAt),
        }, 'debug');
      }
    }),
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && isErrorFromRequest(error, req)) {
        diagnostics.captureHttpError(error, req, Math.round(performance.now() - startedAt));
      }
      return throwError(() => error);
    })
  );
};

function isMutatingRequest(method: string): boolean {
  return method === 'POST' || method === 'PUT' || method === 'PATCH' || method === 'DELETE';
}

function isErrorFromRequest(error: HttpErrorResponse, request: HttpRequest<unknown>): boolean {
  if (!error.url) {
    return true;
  }

  return urlsMatch(error.url, request.urlWithParams || request.url);
}

function urlsMatch(errorUrl: string, requestUrl: string): boolean {
  const actual = errorUrl.toLowerCase();
  const requested = requestUrl.toLowerCase();
  return actual === requested || actual.endsWith(requested);
}
